import makeLookupModal from "../../UI/LookupModal/LookupModal";
import OpportunityAssigneeLookup from "./OpportunityAssigneeLookup";
import { RANDOM_ASSIGNEE_POOL_MAX_AMOUNT } from "../WorkflowNodeDefinition/forms/ChangeAssigneeWorkflowNodeDefinitionForm";
const OpportunityAssigneeLookupModal = makeLookupModal(OpportunityAssigneeLookup, {
    pluralEntityName: "Assignees",
    maxSelectedItems: RANDOM_ASSIGNEE_POOL_MAX_AMOUNT,
});
export default OpportunityAssigneeLookupModal;
